import { InputPhoneNumberComponent } from './input-phone-number/input-phone-number.component';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { PplInputModule } from '@ppl/ui/input';
import { PplLoadingModule } from '@ppl/ui/loading';

@NgModule({ declarations: [
        InputPhoneNumberComponent
    ],
    exports: [
        InputPhoneNumberComponent
    ], imports: [CommonModule,
        PplInputModule,
        PplLoadingModule], providers: [provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())] })
export class PplComponentsInputPhoneNumberModule { }
